module.exports = __webpack_public_path__ + "img/information_ethical_mob.3f2fbab.webp";